(function () {
  'use strict';

  angular
    .module('app.segmentationReportSegment')
    .factory('segmentationReportSegmentService', ['$q', '$http', '$rootScope', 'measureService',
      function ($q, $http, $rootScope, measureService) {
        var service = {};

        function checkResponse(data) {
            return data;
        }

        function getMessage(data) {
            if (data) {
                return data.message;
            }
            return false;
        }

        function handleRequest(url, method, params, loader) {
            var deferred = $q.defer();

            var req = {
                url: url,
                method: method,
                data: JSON.stringify(params),
                loader: loader
            } 

            $http(req)
                .success(function (data) {
                var dataRes = angular.fromJson(data);

                if (checkResponse(dataRes)) {
                    deferred.resolve(dataRes);
                } else {
                    deferred.reject(getMessage(dataRes));
                }
            })
                .error(function (result) {
                    deferred.reject(result);
                });

            return deferred.promise;
        }

        function getSegmentTopicData(params, loader){
            var url = $rootScope.apiUrl + 'measure/getSegmentTopics?' + $.param(params);
            return handleRequest(url, 'GET', null, loader);
        }

        service.getSegmentTopicData = getSegmentTopicData;

        return service;
      }]);
})();